<script setup>
    import { defineEmits } from 'vue';
    import { useButtonDisabledStore } from '@/stores/common/disabledStore';

    // ボタン連打ガード制御
    const disabledStore = useButtonDisabledStore();

    /**
     * 親画面で実装必須関数
     */
    const emit = defineEmits(['deletedModal:close', 'deletedModal:delete']);
    function close() {
        // 親画面のキャンセル処理を呼び出す
        emit('deletedModal:close');
    }
    function deletedOk() {
        // ボタン連打ガード制御
        disabledStore.buttonTemporaryDisabled();

        // 親画面の削除処理を呼び出す
        emit('deletedModal:delete');
    }
</script>

<style></style>

<template>
    <article id="modalWebConsultationEntryCheck" class="modal small" :style="{ display: 'block' }">
        <p class="textCenter" style="height: 37px;">{{ $t('DeleteConfirm.parts.pageTitle1') }}</p>
        <section class="modalFooter">
            <ul class="btnArea center">
                <li>
                    <button type="button" class="btnNormal" style="width: 180px" id="backWebConsultationEntry" @click="close">{{ $t('DeleteConfirm.parts.button1') }}</button>
                </li>
                <li>
                    <button type="button" class="btnPrimary" style="width: 180px" id="webConsultationEntryComplete" @click="deletedOk()" :disabled="disabledStore.isDisabled">{{ $t('DeleteConfirm.parts.button2') }}</button>
                </li>
            </ul>
        </section>
    </article>
</template>
